import type { PayloadInterface } from '~/types/AppData/AppDataInterface';
import type { CardContentInterface } from '~/types/CardContentInterface';

export const getLdArticleEach = (
  payload: PayloadInterface,
  article: CardContentInterface
) => {
  return JSON.stringify({
    '@context': 'https://schema.org',
    '@type': 'NewsArticle',
    '@id': article.cardLink,
    headline: article.title,
    description: article.seoDescription,
    author: {
      '@type': 'Person',
      name: article.authors?.length ? article.authors[0].name : 'Unknown',
    },
    datePublished: article.createdAtUnformattedDate,
    dateModified: article.unformattedDate,
    mainEntityOfPage: {
      '@type': 'WebPage',
      '@id': payload.canonicalURL,
    },
  });
};
